import e from "./isPreOrderServiceTime.mjs";
import "@ancon/wildcat-types";
function d(r) {
  return e(r == null ? void 0 : r.serviceTime);
}
export {
  d as default
};
